module.exports = __webpack_public_path__ + "static/media/kennel.b8e14ffd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/kennel.svg
// module id = 185
// module chunks = 0